import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";


import Home from "../../assets/home.png";
import ProductDesign from "../../assets/design-thinking.png";
import SoftwareDevelopment from "../../assets/web-development.png";
import Hardware from "../../assets/embedded.png";
import MachineLearning from "../../assets/deep-learning.png";

const useStyles = makeStyles((theme) => ({
  specialText: {
    fontFamily: "Pacifico",
    color: theme.palette.common.orange,
  },
  subtitle: {
    marginBottom: "1em",
  },
  icon: {
    marginLeft: "2em",
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  serviceContainer: {
    marginTop: "5em",
    [theme.breakpoints.down("md")]: {
      padding: 2,
    },
  },
  learnButton: {
    ...theme.typography.learnButton,
    fontSize: "0.7rem",
    height: 35,
    padding: 5,
    [theme.breakpoints.down("md")]: {
      marginBottom: "2em",
    },
  },
}));

export default function Activities(props) {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid container direction="column">
      <Grid
        item
        style={{
          marginLeft: matchesSM ? 0 : "5em",
          marginTop: matchesSM ? "1em" : "2em",
        }}
      >
        <Typography
          align={matchesSM ? "center" : "center"}
          variant="h2"
          gutterBottom
        >
          Club Activities
        </Typography>
      </Grid>
      <Grid item>
        {/*-----Civil & Architectural Design Workshops-----*/}
        <Grid
          container
          direction="row"
          justifyContent={matchesSM ? "center" : "flex-end"}
          className={classes.serviceContainer}
          style={{ marginTop: matchesSM ? "0.5em" : "5em" }}
        >
          <Grid
            item
            style={{
              textAlign: matchesSM ? "center" : undefined,
              width: matchesSM ? undefined : "35em",
            }}
          >
            <Typography variant="h4">Civil & Architectural Design Workshops</Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Design your home today!
            </Typography>
            <Typography variant="subtitle1">
              Learn how to design with softwares such as Revit to design
              {matchesSM ? null : <br />} your future home.
            </Typography>
          </Grid>
          <Grid item style={{ marginRight: matchesSM ? 0 : "5em" }}>
            <img
              className={classes.icon}
              alt="Civil workshops"
              src={Home}
              width="250em"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {" "}
        {/*-----Product Design Workshops-----*/}
        <Grid
          container
          direction="row"
          justifyContent={matchesSM ? "center" : "flex-end"}
          className={classes.serviceContainer}
          style={{ marginTop: matchesSM ? "1em" : "5em" }}
        >
          <Grid
            item
            style={{
              textAlign: matchesSM ? "center" : undefined,
              width: matchesSM ? undefined : "35em",
            }}
          >
            <Typography variant="h4">Product Design Workshops</Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Build devices that are aesthetically appealing!
            </Typography>
            <Typography variant="subtitle1">
              Learn how to use product design software such as Fusion 360
              {matchesSM ? null : <br />} to design aesthetically appealing devices.
            </Typography>
          </Grid>
          <Grid item style={{ marginRight: matchesSM ? 0 : "5em" }}>
            <img
              className={classes.icon}
              alt="product design"
              src={ProductDesign}
              width="250em"
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        {" "}
        {/*-----Programming Workshops-----*/}
        <Grid
          container
          direction="row"
          justifyContent={matchesSM ? "center" : undefined}
          className={classes.serviceContainer}
        >
          <Grid
            item
            style={{
              marginLeft: matchesSM ? 0 : "5em",
              textAlign: matchesSM ? "center" : undefined,
            }}
          >
            <Typography variant="h4">Programming Workshops</Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Learn web and mobile application development!
            </Typography>
            <Typography variant="subtitle1">
              Leverage on web and mobile technologies to build 
              <span className={classes.specialText}>
                 solutions to some of the societal problems
              </span>
            </Typography>
          </Grid>
          <Grid item>
            <img
              className={classes.icon}
              alt="software development"
              src={SoftwareDevelopment}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item>
        {" "}
        {/*-----Hardware Design & Development Workshops-----*/}
        <Grid
          container
          direction="row"
          justifyContent={matchesSM ? "center" : "flex-end"}
          className={classes.serviceContainer}
          style={{ marginBottom: "10em" }}
        >
          <Grid
            item
            style={{
              textAlign: matchesSM ? "center" : undefined,
              width: matchesSM ? undefined : "35em",
            }}
          >
            <Typography variant="h4">Hardware Design & Programming Workshops</Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Lets tinker and build amazing devices!
            </Typography>
            <Typography variant="subtitle1">
              Ever interested in DIY Electronics projects, this is the place for you.
            </Typography>
          </Grid>
          <Grid item style={{ marginRight: matchesSM ? 0 : "5em" }}>
            <img
              className={classes.icon}
              alt="hardware-developers"
              src={Hardware}
              width="250em"
            />
          </Grid>
          <Grid item>
        {" "}
        {/*-----Machine Learning-----*/}
        <Grid
          container
          direction="row"
          justifyContent={matchesSM ? "center" : "flex-end"}
          className={classes.serviceContainer}
          style={{ marginTop: matchesSM ? "1em" : "5em" }}
        >
          <Grid
            item
            style={{
              textAlign: matchesSM ? "center" : undefined,
              width: matchesSM ? undefined : "35em",
            }}
          >
            <Typography variant="h4">Machine Learning Workshops</Typography>
            <Typography variant="subtitle1" className={classes.subtitle}>
              Lets get involved with AI
            </Typography>
            <Typography variant="subtitle1">
              Learn how to leverage on AI technologies to build applications
              {matchesSM ? null : <br />}with Artificial Intelligence at heart.
            </Typography>
          </Grid>
          <Grid item style={{ marginRight: matchesSM ? 0 : "5em" }}>
            <img
              className={classes.icon}
              alt="machine learning"
              src={MachineLearning}
              width="250em"
            />
          </Grid>
        </Grid>
      </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}